import api from ".";

export default {
    getUggy() {
        return api.get("/integrations/uggy").then((response) => {
            return response.data;
        });
    },

    getKlaro() {
        return api.get("/integrations/klaro").then((response) => {
            return response.data;
        });
    },
};
